<template>
  <div id="app">
  	<router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  data: function(){
  	return {
  	}
  },
  created: function(){
  }
}
</script>


<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	font-family: "微软雅黑","microsoft yahei","microsoft sans serif";
	font-size: 4vw;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -ms-tap-highlight-color: rgba(0, 0, 0, 0);
	-moz-tap-highlight-color: rgba(0, 0, 0, 0);
	-o-tap-highlight-color: rgba(0, 0, 0, 0);
	tap-highlight-color: rgba(0, 0, 0, 0);
}
body{ background: #fff;}
ul,
ol,
li{ list-style: none;}
img{ max-width: 100%; border: none;}
a{ color: #333; text-decoration: none; transition: all .2s ease-out 0s;}
a:hover{ color: #333;}

#app{ width: 100vw; height: auto; min-height: 100vh; overflow: hidden;}
</style>


// WEBPACK FOOTER //
// src/App.vue